import { BaseError } from '@superbet-group/web.lib.utilities';

import { LimitType } from '@core/models/user/Limit';

export default class LimitError extends BaseError {
    public readonly type?: LimitType;
    public static readonly code = 800;

    constructor(type?: LimitType) {
        super();
        this.type = type;
    }
}
